import { isFlightCardSavedItemData, type TransportOption } from 'tripPlanner/api/types'

export function buildFlightName(option: TransportOption, fallback: string): string {
  const saved = option.savedItemData
  if (!isFlightCardSavedItemData(saved)) return option.label || fallback
  const route = saved.departureAirport && saved.arrivalAirport
    ? `${saved.departureAirport} → ${saved.arrivalAirport}`
    : undefined
  return [saved.airline, saved.flightNumber, route].filter(Boolean).join(' ')
    || option.label
    || fallback
}
